import { createFileRoute, Link } from "@tanstack/react-router";
import { AppTabList, type TabType } from "@components/AppTabList.tsx";
import PeopleDataGrid from "@components/annuaire/people/datagrid/PeopleDatagrid.tsx";
import OrganizationsDatagrid from "@components/annuaire/organizations/datagrid/OrganizationsDatagrid.tsx";
import { Tab } from "@mui/material";
import { TabPanel, TabContext } from "@mui/lab";
import { Icon } from "@iconify/react";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN } from "@/constants";

type SearchParams = {
  autoFocus?: "search";
}

export const Route = createFileRoute("/_dashboard/annuaire/$tab")({
  beforeLoad: (args) => {
    requireRole([ROLE_ADMIN])(args);
  },
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    if (search.autoFocus === "search") {
      return {
        autoFocus: search.autoFocus,
      };
    }
    return { autoFocus: undefined };
  },
  component: AnnuaireTabs,
});

function AnnuaireTabs() {
  const { autoFocus } = Route.useSearch();
  const TABS: TabType[] = [
    {
      label: "Personnes",
      value: "people",
      href: "/annuaire/people",
      icon: "tabler:users",
      children: (
        <>
          <PeopleDataGrid />
        </>
      ),
    },
    {
      label: "Etablissements",
      value: "organizations",
      href: "/annuaire/organizations",
      icon: "tabler:building",
      children: (
        <>
          <OrganizationsDatagrid autoFocus={autoFocus} />
        </>
      ),
    },
  ];

  const { tab } = Route.useParams();

  return (
    <TabContext value={tab}>
      <AppTabList>
        {TABS.map((tab) => (
          <Tab
            component={Link}
            key={tab.value}
            label={tab.label}
            value={tab.value}
            href={tab.href ?? tab.value}
            {...(tab.icon && {
              icon: <Icon fontSize="18" icon={tab.icon} />,
            })}
            iconPosition={"start"}
          />
        ))}
      </AppTabList>
      {TABS.map((tab) => (
        <TabPanel
          value={tab.value}
          key={tab.value}
          sx={{
            padding: 0,
          }}
        >
          {tab.children}
        </TabPanel>
      ))}
    </TabContext>
  );
}
